import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Clock } from "lucide-react";
import moment from "moment-timezone";
import type { OverviewActivityItem } from "../../../types/dashboard";
import styles from "../Dashboard.module.scss";

export default function RecentActivityPanel({
  items,
}: {
  items: OverviewActivityItem[];
}): JSX.Element {
  return (
    <section className={styles.panel}>
      <div className={styles.panelHeader}>
        <div className={styles.panelTitleWrap}>
          <span className={styles.panelGlyph}>
            <Clock size={16} />
          </span>
          <div>
            <h3 className={styles.panelTitle}>Recent Activity</h3>
            <p className={styles.panelKicker}>Latest changes across the site</p>
          </div>
        </div>
        <Link to="/logreport" className={styles.panelLink}>
          Log Report <ArrowRight size={14} />
        </Link>
      </div>
      {items.length === 0 ? (
        <div className={styles.empty}>
          <p className="mb-0">No recent activity to show.</p>
        </div>
      ) : (
        <div className={styles.timeline}>
          {items.map((item) => (
            <div key={item.id} className={styles.activityRow}>
              <span className={styles.activityDot}>
                <Clock size={14} />
              </span>
              <div className={styles.rowBody}>
                <p className={styles.rowTitle}>
                  {item.summary || item.eventType || item.action || "Activity"}
                </p>
                <p className={styles.rowMeta}>
                  <span>{item.actorName || "System"}</span>
                  {item.module ? <span>{item.module}</span> : null}
                  {item.createdTime ? (
                    <span>
                      {moment(item.createdTime)
                        .tz("America/New_York")
                        .fromNow()}
                    </span>
                  ) : null}
                </p>
              </div>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}
